import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop(): null {
  const { pathname }: { pathname: string } = useLocation();

  useEffect((): void => {
    window.scroll({ top: 0 });
  }, [pathname]);

  return null;
}
